import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginLayoutComponent } from './auth/authLayout/loginlayout.component';
import { ChangePasswordComponent } from './auth/reset-password/chage-password/chage-password.component';
import { PasswordResetComponent } from './auth/reset-password/password-reset/password-reset.component';
import { FactcheckComponent } from './auth/sign-in/factcheck/factcheck.component';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { AuthRepDashComponent } from './components/authDash/authrepdash.component';
import { AccessReportsComponent } from './pages/accessreports/accessreports.component';
import { TransReportsComponent } from './pages/accessreports/TransactionsReports/transactionreports.component';
import { AddAccountsviewComponent } from './pages/AccountForm/addAccounts.component';
import { AdminComponent } from './pages/admin/admin.component';
import { AdvisorsComponent } from './pages/advisors/advisors.component';
import { BookmarktransactionComponent } from './pages/bookmarktransaction/bookmarktransaction.component';
import { CapitalFaxComponent } from './pages/capfax/capitalfax.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DeletedBlotterReportsComponent } from './pages/deletedblotter/deletedblotter.component';
import { FincenComponent } from './pages/fincen/fincen.component';
import { FincenreportsComponent } from './pages/fincen/fincenreports/fincenreports.component';
import { MarketingEditorComponent } from './pages/marketing/marketing-editor/marketing-editor.component';
import { MarketingComponent } from './pages/marketing/marketing.component';
import { PendingalertsComponent } from './pages/pendingalerts/pendingalerts.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { RepEditorComponent } from './pages/reps/rep-editor/rep-editor.component';
import { TypeEditorComponent } from './pages/reps/type-editor/type-editor.component';
import { ViewRepsComponent } from './pages/reps/view-reps/view-reps.component';
import { TransactionRestorationComponent } from './pages/restoration/transaction-restoration/transaction-restoration.component';
import { TabsViewComponent } from './pages/TabsScreen/tabs.component';
import { TransactionDetailsComponent } from './pages/transaction-list/transaction-details/transaction-details.component';
import { TransactionListComponent } from './pages/transaction-list/transaction-list.component';
import { TransactionViewerComponent } from './pages/Transactions/TransViewer.component';
import { UserPreferencesComponent } from './pages/user-preferences/user-preferences.component';
import { UserComponent } from './pages/users/user/user.component';
import { ViewAccountsComponent } from './pages/viewaccounts/viewaccounts.component';
import { GetPDFDisclosureComponent } from './Pdfviewer/disclosure-forms/disclosure-forms.component';
import { NgxRegisterComponent } from './auth/register/register.component';
export const routes: Routes = [
  {
    path: '',
    component: LoginLayoutComponent,
    children: [{ path: '', component: SignInComponent }],
  },
  // {
  //   path: 'app',
  //   loadComponent: () => import('./pages/pageLayout/pagelayout.component').then(c => c.PageLayoutComponent),
  //   children: [
  //     {
  //       path: '',
  //       redirectTo: 'Dashboard', // Default to 'dashboard'
  //       pathMatch: 'full'
  //     },
  //     {
  //       path: 'Dashboard',
  //       component: DashboardComponent
  //     },
  //     {
  //       path: 'dashboard',
  //       component: DashboardComponent
  //     },
  //     {
  //       path: 'app',
  //       component: DashboardComponent
  //     },

  //   ]
  // },
  {
    path: 'pages',
    loadComponent: () =>
      import('./pages/pageLayout/pagelayout.component').then(
        (c) => c.PageLayoutComponent
      ),
    children: [
      {
        path: 'viewaccounts/view-accounts',
        component: ViewAccountsComponent,
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'TransactionList/view',
        component: TransactionListComponent,
      },
      {
        path: 'TransactionList/details',
        component: TransactionDetailsComponent,
      },
      {
        path: 'AccountForm/add-account',
        component: AddAccountsviewComponent,
      },
      {
        path: 'AccountForm/edit-account',
        component: AddAccountsviewComponent,
      },
      {
        path: 'AccountForm/new-accountview',
        component: AddAccountsviewComponent,
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'viewaccounts/view-accounts',
        component: ViewAccountsComponent,
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'user-preferences',
        component: UserPreferencesComponent,
      },
      {
        path: 'capfax',
        component: CapitalFaxComponent,
      },
      {
        path: 'TabsScreen/tab-views',
        component: TabsViewComponent,
      },
      {
        path: 'capfax/wordfax',
        component: CapitalFaxComponent,
      },
      {
        path: 'Pdfviewer/disclosedFilePath',
        component: GetPDFDisclosureComponent,
      },
      {
        path: 'accessreports/capitaltransactionsexport',
        component: TransReportsComponent,
      },
      {
        path: 'accessreports/reportexport',
        component: AccessReportsComponent,
      },
      {
        path: 'advisors/AdvisorClients',
        component: AdvisorsComponent,
      },
      {
        path: 'deletedblotter/deletedblottereport',
        component: DeletedBlotterReportsComponent,
      },
      {
        path: 'bookmark-trans',
        component: BookmarktransactionComponent,
      },
      {
        path: 'bookmark-trans',
        component: MarketingComponent,
      },
      {
        path: 'Reports/default',
        component: ReportsComponent,
      },
      {
        path: 'admin/base',
        component: AdminComponent,
      },
      {
        path: 'rep-editor/edit',
        component: RepEditorComponent,
      },
      {
        path: 'view-reps/default',
        component: ViewRepsComponent,
      },
      {
        path: 'type-editor/edit',
        component: TypeEditorComponent,
      },
      {
        path: 'restoration/transaction',
        component: TransactionRestorationComponent,
      },
      {
        path: 'users/registerrep',
        component: AuthRepDashComponent,
      },
      {
        path: 'users/register',
        component: NgxRegisterComponent,
      },
      {
        path: 'users/current',
        component: UserComponent,
      },
      {
        path: 'marketing/view',
        component: MarketingComponent,
      },
      { path: 'marketing/edit', component: MarketingEditorComponent },
      {
        path: 'Transactions/app-transviewer',
        component: TransactionViewerComponent,
      },
      { path: 'restoration/transaction', component: TransactionRestorationComponent },
      {
        path: 'users/reset-password',
        component: PasswordResetComponent
      },
      {
        path: 'pending-alerts',
        component: PendingalertsComponent,
      },
      {
        path: 'fincen',
        component: FincenComponent
      },
      {
        path: 'fincenreports',
        component: FincenreportsComponent
      }
    ],
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./auth/authLayout/loginlayout.component').then(
        (c) => c.LoginLayoutComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'auth', // Default to 'auth' if no path is specified
        pathMatch: 'full',
      },
      {
        path: 'auth',
        component: SignInComponent,
      },
      {
        path: 'reset-pass',
        component: ChangePasswordComponent,
      },
      {
        path: 'change-password',
        component: PasswordResetComponent,
      },
      {
        path: 'reset-password',
        component: PasswordResetComponent,
      },
      {
        path: 'reset-passes',
        component: PasswordResetComponent,
      },
      {
        path: 'verify-user',
        component: FactcheckComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];
NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 64],
      onSameUrlNavigation: 'reload',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
});
export class AppRoutingModule { }
